__turbopack_context__.v({
  "select": "product-region-select-module-scss-module__qRRd5W__select",
});
